import styled, { keyframes } from "styled-components";
import { Overlay } from "@swiggy-private/core-ui";

const UX4_HEADER_HEIGHT_PX = "64px";

const moveAnimation = keyframes`
    50% {
        transform: translate3d(100vw, 0, 0);
    }
`;

export const StyledOverlay = styled(Overlay)`
    background: ${({ theme }) => theme.colors[theme.colorMode].background_Primary};
    pointer-events: auto;
`;

export const MovingTrayContainer = styled.div`
    position: fixed;
    top: ${UX4_HEADER_HEIGHT_PX};
    left: 0;
    z-index: 1024888;
    transform: translateZ(0);
    backface-visibility: hidden;

    @supports (top: var(--sat)) {
        top: calc(var(--sat, 0px) + ${UX4_HEADER_HEIGHT_PX});
    }
`;

export const MovingTray = styled.div`
    width: 16px;
    background-color: ${({ theme }) => theme.colors[theme.colorMode].primary};
    height: 2px;
    transform: translateZ(0);
    will-change: transform;
    backface-visibility: hidden;
    animation: ${moveAnimation} linear 2s infinite;
`;
